/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';

/**
 * 
 * @export
 * @interface ApprenantHistorySearch
 */
export interface ApprenantHistorySearch {
    /**
     * 
     * @type {number}
     * @memberof ApprenantHistorySearch
     */
    idapprenant?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ApprenantHistorySearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof ApprenantHistorySearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof ApprenantHistorySearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ApprenantHistorySearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof ApprenantHistorySearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof ApprenantHistorySearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the ApprenantHistorySearch interface.
 */
export function instanceOfApprenantHistorySearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ApprenantHistorySearchFromJSON(json: any): ApprenantHistorySearch {
    return ApprenantHistorySearchFromJSONTyped(json, false);
}

export function ApprenantHistorySearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApprenantHistorySearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idapprenant': !exists(json, 'idapprenant') ? undefined : json['idapprenant'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function ApprenantHistorySearchToJSON(value?: ApprenantHistorySearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idapprenant': value.idapprenant,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

